/* eslint max-len: ["error", { "ignoreStrings": true }] */

const metaInfo = {
  // SEO metadata
  brands: {
    en: 'Binance',
    cn: '币安',
    tw: '币安',
    kr: '바이낸스',
    ru: 'Бинанс',
    es: 'Binance',
    fr: 'Binance',
    de: 'Binance',
    vn: 'Binance',
    tr: 'Binance',
    nl: 'Binance',
    pt: 'Binance',
    it: 'Binance',
    pl: 'Binance',
  },
  metaTitles: {
    en: 'Bitcoin Exchange | Cryptocurrency Exchange | Binance',
    cn: '比特币交易平台 | 数字货币交易平台 | 币安',
    tw: '比特幣交易平台 | 數字貨幣交易平台 | 币安',
    kr: '비트코인 거래소 | 암호화폐 거래소 | Binance',
    ru: 'Биткоин Биржа | Криптовалютная Биржа | Binance',
    es: 'Bitcoin Exchange | Exchange de Criptomonedas | Binance',
    fr: "La plateforme d'échange de Bitcoin | La plateforme d'échange de cryptomonnaies | Binance",
    de: 'Bitcoin Börse | Börse für Kryptowährungen | Binance',
    vn: 'Sàn giao dịch Bitcoin | Sàn giao dịch tiền mã hoá | Binance',
    tr: 'Bitcoin Borsası | Kriptopara Borsası | Binance',
    nl: 'Bitcoin Handelsplatform | Cryptocurrency Handelsplatform | Binance',
    pt: 'Bitcoin Exchange | Exchange de criptomoedas | Binance',
    it: 'Bitcoin Exchange | Exchange di criptovalute | Binance',
    pl: 'Giełda Bitcoin | Giełda kryptowalut | Binance',
  },
  metaKeywords: {
    // en is fallback
    en:
      'Blockchain Crypto Exchange, Cryptocurrency Exchange, Bitcoin Trading, Ethereum price trend, BNB, CZ, BTC price, ETH wallet registration, LTC price, Binance, Poloniex, Bittrex',
    cn:
      '区块链资产交易平台,币币交易,数字货币交易网,虚拟货币账户,比特币交易系统,以太坊行情,莱特币走势,BNB,赵长鹏,BTC价格,ETH钱包注册,LTC市价,币安,杠杆期货,Binance',
    tw:
      '区块链资产交易平台,币币交易,数字货币交易网,虚拟货币账户,比特币交易系统,以太坊行情,莱特币走势,BNB,赵长鹏,BTC价格,ETH钱包注册,LTC市价,币安,杠杆期货,Binance',
    kr:
      '블록체인 거래소, 가상화폐 거래소, 비트코인 거래, 이더리움 가격 동향, BNB, CZ, BTC 시세, ETH 지갑 등록, LTC 비세, 바이낸스, 폴로니엑스. 비트렉스',
    ru:
      'Блокчен криптовалютная биржа, Криптовалютная биржа, Торговля на биткоин, ценовой тренд Ethereum, BNB, CZ, цена BTC, регистрация кошелька ETH, цена LTC, бинанс, Poloniex, Bittrex',
    es:
      'Cripto Monedas Blockchain Exchange, Compra Venta de Bitcoin, Tendencia de Precio Ethereum, BNB, CZ, BTC precio, ETH registro cartera, LTC precio, Binance, Poloniex, Bittrex',
    fr:
      'Cryptomonnaie Blockchain Echange, Cryptommonaie Echange, Achat Vente de Bitcoin, Tendance des prix ETH, BNB, CZ, Prix du BTC, ETH création de porte-monnaie, Prix du LTC, Binance, Poloniex, Bittrex',
    de:
      'Blockchain und Krypto- Handelsplattform, Handelsplattform für Kryptowährung, Bitcoin Handeln, Ethereum Preis Trend, BNB, CZ, BTC Preis, ETH-Wallet Anmeldung, LTC Preis, Binance, Poloniex, Bittrex',
    vn:
      'Sàn giao dịch Blockchain Crypto, Sàn giao dịch Cryptocurrency, Bitcoin Trading, xu hướng giá Ethereum , BNB, CZ, giá BTC, đăng kí ví ETH , giá LTC, Binance, Poloniex, Bittrex',
    tr:
      'Blockchain Kripto Borsası, Kripto Para Borsası,Bitcoin alım satım, Ethereum fiyat trendi,BNB,CZ,BTC fiyatı, Ethereum cüzdan kaydı,LTC fiyatı, Binance, Poloniex, Bittrex.',
    nl:
      'Blockchain Crypto wisselkoers, Cryptocurrency wisselkoers, Bitcoin handel, Ethereum prijsontwikkeling, BNB, CZ, BTC-prijs, ETH-portemonnee-registratie, LTC-prijs, Binance',
    pt:
      'Criptomoedas, Blockchain Cripto Bolsa, Bolsa de Criptomoedas, Bitcoin Trading, Tendência de preços Ethereum, BNB, CZ, preço BTC, registro carteira ETH, preço LTC, Binance',
    it:
      'chiave: Blockchain Piattaforma di scambio di Cripto, Criptomonete, Piattaforma di scambio, Trading di Bitcoin, Trend del prezzo di Ethereum, BNB, CZ, Prezzo di BTC, Registro del Portafoglio di ETH, Prezzo di LTC, Binance, Poloniex, Bittrex',
    pl:
      'Giełda wymiany kryptowalut, handel kryptowalutami, handel walutami cyfrowymi, konto do walut wirtualnych, system handlu bitcoinami, rynek Ethereum, Litecoin, BNB, Zhao Changpeng, cena BTC, rejestracja portfela ETH, cena rynkowa LTC, opcje futures, Binance',
  },
  metaDescriptions: {
    // en is fallback
    en:
      'Binance cryptocurrency exchange - We operate the worlds biggest bitcoin exchange and altcoin crypto exchange in the world by volume',
    cn: '币安是全球领先的数字货币交易平台，提供比特币、以太坊、BNB以及USDT交易',
    tw: '幣安是全球領先的數字貨幣交易平台，提供比特幣、以太坊、BNB以及USDT交易',
    kr:
      '바이낸스 암호화폐 거래소 - 비트코인과 알트코인을 거래할 수 있는 전세계 최대 규모의 암호화폐 거래소입니다',
    ru:
      'Криптовалютная биржа Binance - Мы управляем крупнейшей в мире криптовалютной биржей Биткоин и альткоинов по объему',
    es:
      'Binance Exchange de Criptomonedas - Operamos el exchange de criptomonedas con mayor volumen en el mundo',
    fr:
      'Binance est une plateforme avancée qui vous propose d’échanger BTC, ETH, BNB et d’autres cryptomonnaies',
    de:
      'Binance Börse für Kryptowährungen – Wir betreiben für Bitcoin und Altcoins die größte Börse der Welt nach Tradingvolumen',
    vn:
      'Sàn giao dịch tiền mã hoá Binance - Chúng tôi là sàn giao dịch Bitcoin và Altcoin với khối lượng giao dịch lớn nhất thế giới',
    tr:
      'Binance kriptopara borsası - Dünyanın en yüksek hacimli bitcoin ve altcoin borsasını işletiyoruz',
    nl:
      "Binance cryptocurrency handelsplatform - Wij beheren's werelds grootste bitcoin en altcoin handelsplatform in de wereld gebaseerd op volume",
    pt:
      'Binance, exchange de criptomoedas - nós operamos a maior exchange de bitcoin e altcoins do mundo por volume',
    it:
      'Binance, exchange di criptovalute - Il maggior exchange di bitcoin e criptovalute del mondo per volume',
    pl:
      'Binance - największa na świecie giełda bitcoina i kryptowalut pod względem wolumenów handlowych',
  },
};

export default metaInfo;
